import { PageHero } from "../components/PageHero";
import { Fleet } from "../components/Fleet";
import { CTABand } from "../components/CTABand";
import { Reveal, Overline } from "../components/Reveal";
import { Cpu, Building2, Plane } from "lucide-react";

const extras = [
  { icon: Cpu, title: "FNPT II Simulator", text: "Practise procedures and instrument work in our full flight simulator — safe, efficient and cost-effective." },
  { icon: Cpu, title: "Garmin G1000 Glass Cockpit", text: "Our G1000-equipped aircraft — such as ZS-PWW — bring modern EFIS avionics to your training, mirroring the flight decks of today's airliners." },
  { icon: Building2, title: "On-Field Maintenance", text: "Our aircraft are maintained to the highest standards with Rand Airport's on-field engineering support." },
];

export default function FleetPage({ onApply }) {
  return (
    <>
      <PageHero media="/img/tail.webp" mediaType="image" overline="Our Fleet" title="Trained on the world's most trusted" highlight="trainer." subtitle="Eagle 1 operates a dedicated Cessna 172 fleet — including glass-cockpit aircraft such as ZS-PWW, for hour building and instrument training." />
      <Fleet />
      <section className="py-24 lg:py-32 bg-[var(--paper)]" data-testid="fleet-extras">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-2xl mb-14">
            <Reveal><Overline>Beyond the Aircraft</Overline></Reveal>
            <Reveal delay={0.1}><h2 className="mt-5 font-display font-light text-4xl md:text-5xl tracking-tight text-[var(--primary)]">Technology that accelerates learning.</h2></Reveal>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {extras.map((e, i) => (
              <Reveal key={e.title} delay={i * 0.1}>
                <div className="rounded-2xl bg-white border border-[var(--line)] p-8 card-shadow h-full">
                  {e.img ? (
                    <div className="h-16 w-24 rounded-xl overflow-hidden border border-[var(--line)]"><img src={e.img} alt={e.title} className="h-full w-full object-cover" /></div>
                  ) : (
                    <div className="h-14 w-14 rounded-2xl bg-navy flex items-center justify-center"><e.icon size={26} className="text-accent-2" /></div>
                  )}
                  <h3 className="mt-6 font-display text-xl font-semibold text-[var(--primary)]">{e.title}</h3>
                  <p className="mt-3 text-sm text-[var(--muted)] leading-relaxed">{e.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTABand onApply={onApply} title="Come see the fleet for yourself." text="Book a discovery flight and take the controls of our Cessna 172 over Johannesburg." />
    </>
  );
}
